export const defaultState = {
  name: '',
  country: null,
  initials: '',
  memberAssociation: null,
  cbHeadName: '',
  cbHeadEmail: '',
  cbHeadTelephone: '',
  contactName: '',
  contactEmail: '',
  contactTelephone: '',
  address: {
    line1: '',
    line2: '',
    postCode: '',
    city: '',
    country: null,
  },
  invoiceAddressSame: true,
  invoiceAddress: {
    line1: '',
    line2: '',
    postCode: '',
    city: '',
    country: null,
  },
  vatId: '',
  user: null,
  operational: null,
};

const UPDATE_FIELD = 'UPDATE_FIELD';

export const updateFieldCreator = (payload) => ({ type: UPDATE_FIELD, payload });

export default function (state = defaultState, action) {
  if (action.type === UPDATE_FIELD) {
    return { ...state, [action.payload.name]: action.payload.value };
  }

  return state;
}